"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _UIErrorMessage = _interopRequireDefault(require("UIComponents/error/UIErrorMessage"));

var LoadingErrorPage = function LoadingErrorPage() {
  return _react.default.createElement(_UIErrorMessage.default, {
    title: (0, _unescapedText.default)('loadingErrorHeader')
  }, _react.default.createElement("p", null, _react.default.createElement(_FormattedHTMLMessage.default, {
    message: "loadingErrorSubHeader"
  })));
};

var _default = LoadingErrorPage;
exports.default = _default;
module.exports = exports.default;